import React from "react";
import { MapPin, Download } from "lucide-react";
import { useParams } from "react-router-dom";
import credit from "../../../assets/img/trasparent credit.svg";
import apple from "../../../assets/img/apple store dark icon.svg";
import android from "../../../assets/img/play store Light Icon.svg";
import tick from "../../../assets/img/tick Credits Added.svg";
import add_credit from "../../../assets/img/blue Credits Added.svg";

const AddServiceAreaWebFromMobileThankYouPage = () => {
  const { credits } = useParams();
  return (
    <div
      className="custom_container"
      style={{ paddingTop: 120, marginBottom: 40 }}
    >
      <div className="pro-welcome">
        <div className="pro-welcome-head">
          <div className="phone-icon">
            <img src={credit} alt="credit" />
          </div>

          <h1 className="title">Credits Added!</h1>
          <p className="subtitle">{credits} credits have been added to your account</p>
        </div>
        <div className="pro-welcome-secound-sec">
          <div className="next-step">
            <div className="next-step-header">
              <img src={add_credit} alt="add credit" />
              <h2>Credits</h2>
            </div>
            <p className="next-step-text two-line-text">
              Credits power your bidding on SimpleRenovate. Each credit equals $1.00 with no hidden fees.
            </p>
          </div>

          <div className="features-section">
            <h3 className="features-title">How Credits Work</h3>

            <div className="feature-item">
              <div className="feature-icon ">
                <img src={tick} alt="tick" />
              </div>
              <div className="feature-content">
                <h4>Simple Pricing</h4>
                <p>1 credit = $1.00 with no hidden fees </p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon ">
                <img src={tick} alt="tick" />
              </div>
              <div className="feature-content">
                <h4>Valid for 12 Months</h4>
                <p>Active for 12 months from issuance or last activity.</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <img src={tick} alt="tick" />
              </div>
              <div className="feature-content">
                <h4>Instant Delivery</h4>
                <p>Credits remain active as long as your account is active</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <img src={tick} alt="tick" />
              </div>
              <div className="feature-content">
                <h4>Secure Processing</h4>
                <p>Payments processed through Stripe</p>
              </div>
            </div>
          </div>

          <h5 className="text-center mb-3">Start Bidding Now via App</h5>

          <div className="download-section mb-2">
            <Download className="download-icon" size={24} />
            <h3>Download Our Mobile App</h3>
            <p>Available on iOS - Android coming soon</p>

            <div className="store-buttons">
              <button
                className="store-btn app-store"
                onClick={() => window.open("https://apps.apple.com/us/app/simplerenovate-for-pros/id6754059537", "_blank")}
              >
                <img src={apple} alt="App Store" />
                <div className="store-text">
                  <span className="store-label">App Store</span>
                </div>
              </button>

              <button className="store-btn play-store disabled">
                <div className="play-icon">
                  <img src={android} alt="Play Store" />
                </div>
                <div className="store-text">
                  <span className="store-label">Play Store</span>
                  <span className="store-status">Coming Soon</span>
                </div>
              </button>
            </div>
          </div>

          
        </div>
      </div>
    </div>
  );
};

export default AddServiceAreaWebFromMobileThankYouPage;
